export default {
    root: {
        borderRadius: 11,
    },
};
